import { FIELDS } from 'modules/cm/fields/types';
import {
  nullableString,
  optionalNumberValidationSchema,
  optionalStringValidationSchema,
  positiveCurrencyIncludingZeroValidation,
  postcodeValidation,
} from 'utils/form/validation';
import * as yup from 'yup';
import { Asset } from './Assets.types';

export default yup.object().shape<{
  [FIELDS.ASSETS_PREFIX]: Asset[];
}>({
  [FIELDS.ASSETS_PREFIX]: yup.array().of<Asset>(
    yup.object().shape({
      [FIELDS.ASSETS_ID]: yup.number(),
      [FIELDS.ASSETS_TYPE]: nullableString(),
      [FIELDS.ASSETS_DESCRIPTION]: nullableString(),
      [FIELDS.ASSETS_VALUE]: positiveCurrencyIncludingZeroValidation(),
      [FIELDS.ASSETS_WILL_BE_USED_TO_PAY_LOAN]: yup.boolean().nullable(),
      [FIELDS.ASSETS_OUTSTANDING_MORTGAGE_BALANCE]: optionalNumberValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        positiveCurrencyIncludingZeroValidation(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_POSTCODE]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        postcodeValidation(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_CITY]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        nullableString(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_FLAT_NUMBER]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        nullableString(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_BUILDING_NAME]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        nullableString(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_BUILDING_NUMBER]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        nullableString(),
        true,
      ),
      [FIELDS.ASSETS_PROPERTY_STREET]: optionalStringValidationSchema(
        FIELDS.ASSETS_TYPE,
        'PROPERTY',
        nullableString(),
        true,
      ),
    }),
  ),
});
